export const PRODUCTION = 'production';

export const DEFAULT_PROVINCE_SELECTION: string = 'Province / State';
export const DEFAULT_COUNTRY_SELECTION: string = 'Country';

export const REVERT_TO_INITIAL_STATE = 'REVERT_TO_INITIAL_STATE';
export const REVERT_TO_INITIAL_STATE_EXCEPT_AUTH = 'REVERT_TO_INITIAL_STATE_EXCEPT_AUTH';

export enum ScreenWidth {
  Small = 768,
  Medium = 992,
  Large = 1200
}

export enum MmsColor {
  MmsYellow = '#f8e008',
  MmsDarkGrey = '#43464e',
  MmsLightGrey = '#f4f4f4',
  MmsTextLightGrey = '#869097',
  MmsBlue = '#378ccb',
  Black = '#000000',
  White = '#ffffff',
  MaterialLightRed = '#ff4081',
  LightGrey = '#e9e9e9'
}

export const monthsList = [
  {
    name: 'January',
    value: '01'
  },
  {
    name: 'February',
    value: '02'
  },
  {
    name: 'March',
    value: '03'
  },
  {
    name: 'April',
    value: '04'
  },
  {
    name: 'May',
    value: '05'
  },
  {
    name: 'June',
    value: '06'
  },
  {
    name: 'July',
    value: '07'
  },
  {
    name: 'August',
    value: '08'
  },
  {
    name: 'September',
    value: '09'
  },
  {
    name: 'October',
    value: '10'
  },
  {
    name: 'November',
    value: '11'
  },
  {
    name: 'December',
    value: '12'
  }
];

export enum Days {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY'
}

export const daysList: Array<{name: string, value: string}> = [
  {
    name: 'Sunday',
    value: Days.Sunday
  },
  {
    name: 'Monday',
    value: Days.Monday
  },
  {
    name: 'Tuesday',
    value: Days.Tuesday
  },
  {
    name: 'Wednesday',
    value: Days.Wednesday
  },
  {
    name: 'Thursday',
    value: Days.Thursday
  },
  {
    name: 'Friday',
    value: Days.Friday
  },
  {
    name: 'Saturday',
    value: Days.Saturday
  }
];



// WEBPACK FOOTER //
// ./src/app/app.const.tsx